import {Component, OnInit, Input} from '@angular/core';
import { SoudotecItemsInputModel } from '../soudotec-items-input.model';
import { Model_WorkflowComponent } from '../../../../../app.models';

@Component({
    selector: 'soudotec-items-input-result',
    templateUrl: './soudotec-items-input-result.component.html',
    styleUrls: ['./soudotec-items-input-result.component.scss']
})
export class SoudotecItemsInputResultComponent implements OnInit {
	@Input() model: SoudotecItemsInputModel;
    @Input() value: any[];
    component: Model_WorkflowComponent;
    displayedColumns: string[] = ['AR_CodeBarre', 'AR_Design', 'FA_CodeFamille', 'FA_Intitule', 'QUANTITE'];

    constructor() {
    }

    ngOnInit() {
        this.component = this.model.additional as Model_WorkflowComponent;
    }

    exportToCsv() {
        if (!!this.value) {
        }
    }
}